import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service'
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authSer: AuthenticationService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    var authReq: any = request.clone({
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    });

    if (this.authSer.sessionValue != null) {
      authReq = authReq.clone({ setHeaders: { 'Session': this.authSer.sessionValue, "Apikey": this.authSer.apiKey } });
      // authReq = authReq.clone({ body : authReq.body.append("session_key",this.authSer.sessionValue)   })
    } else {
      authReq = authReq.clone({ setHeaders: { "Apikey": this.authSer.apiKey } });
    }

    return next.handle(authReq);
  }
}
